export default __webpack_public_path__ + "static/media/corporate-package2.cb6bb205.png";